import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as FileUploadIcon } from '@/assets/img/v2/file-upload-icon.svg';
import { ReactComponent as EditIcon } from '@/assets/img/v2/edit-pencil-icon.svg';

import { useUploadPicture } from '../api/addPet';
import { Pet } from '../types';
import './MyPetDetailCard.scss';
import Lottie from 'lottie-react';
import progressAnimation from '@/assets/animation/loading.json';
import { showNotification } from '@/utils/notificationUtils';
import { useTranslation } from 'react-i18next';
type Props = {
  data: Pet;
  onChange: () => void;
};
export const PetDetailCard = ({ data }: Props) => {
  const uploadPictureMutation = useUploadPicture();
  const { t, i18n } = useTranslation();
  const [isUploading, setIsUploading] = useState(false);
  const [petProfilePic, setPetProfilePic] = useState<string>();
  useEffect(() => {
    if (data) {
      setPetProfilePic(data.petsImageUrl);
    }
  }, []);

  const onProfilePicUpload = async (formData: FormData) => {
    const response = await uploadPictureMutation.mutateAsync({
      file: formData,
      petsId: data.id,
    });
    setIsUploading(false);
    setPetProfilePic(response ? response.imageUrl : '');
  };
  const fileInputRef = useRef(null);
  const onFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files as FileList;
    const sFile =  selectedFiles?.[0]
    if (sFile.size > 1500000) {
      showNotification({
        type: 'info',
        title: t('Uploaded image should be less than 1.5 mb .'),
      });
      return false;
    }
    const formData = new FormData();
    formData.append('file',sFile);
    setIsUploading(true);
    onProfilePicUpload(formData);
  };

  const onUploadImageHandler = () => {
    if (!isUploading && fileInputRef && fileInputRef.current) {
      (fileInputRef.current as any).click();
    }
  };
  return (
    <div className="pet-detail-card">
      <div className="inner-section">
        <div className="pet-pic-uploader">
          <div className="image-section" onClick={onUploadImageHandler}>
            {petProfilePic ? (
              <span className="image-holder">
                <img src={petProfilePic} /> {!isUploading && <EditIcon className="edit-icon" />}
              </span>
            ) : (
              <FileUploadIcon />
            )}
            {isUploading && (
              <Lottie className="loader-animation" animationData={progressAnimation} />
            )}

            <input
              type="file"
              onChange={onFileSelect}
              ref={fileInputRef}
              hidden
              placeholder="Attribute name"
            />
          </div>
          <div className='detail-section'>
            <p>{data.name}</p>
            <p className="desc">{data.notes}</p>
            <div className="breed-detail">
              <span title={data.breed}>
                {t('Breed:')} <b>{data.breed}</b>
              </span>
            </div>
          </div>
        </div>
        <div className="breed-detail">
          <span>
            {t('Breed:')} <b>{data.breed}</b>
          </span>
        </div>
      </div>
      <p className="desc">{data.notes}</p>
    </div>
  );
};
